module.exports = __webpack_public_path__ + "static/media/24.6f842db2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/units/24.svg
// module id = 397
// module chunks = 14